import React from 'react';

import Typography from '@material-ui/core/Typography';

import IntlMessageComponent from 'components/formatters/intlMessage';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';


export default function IsoNoCompanySignUpSuccessViewComponent() {
  return (
    <React.Fragment>

      <PageSubTitleViewComponent id="page.IsoNoCompany.h1" />
      
      <Typography variant="body1">
        <IntlMessageComponent id="page.IsoNoCompany.success" />
      </Typography>

    </React.Fragment>
  );
}